export default __webpack_public_path__ + "static/hero-9f2345573e5c2a830fde1e3f5af2844c.jpg";